import { Col } from "react-bootstrap";
import "../App.css"

export const ProjectCard = ({ title, description, imgUrl, link, gtLink,ts1, ts2, ts3,ts4,ts5,ts6,ts7,ts8 }) => {
  return (
    <Col size={12} sm={6} md={4}>
      <div className="proj-imgbxs">
        <img src={imgUrl}/>
        <div className="proj-txtxx">
          <h4 style={{marginTop:"1rem"}}>{title}</h4>
          <span>{description}</span>
          <p style={{marginTop:"2rem"}}>Tech Stacks: 
          <ul>
            {ts1}, {ts2}, {ts3}, {ts4}, {ts5} {ts6} {ts7} {ts8}
            </ul>
          </p>
        </div>

        <div style={{marginTop:"2rem", marginBottom:"2rem", display:"flex", gap:"30px", justifyContent:"center"}}>
          <a href={link} target="_blank">
            <button
              style={{
                color: "black",
                padding: "1rem 1.3rem",
                backgroundColor: "white",
                borderRadius:"20px"
              }}
            >
              🟢 Live
            </button>
          </a>
          <a href={gtLink} target="_blank">
            <button
              style={{
                color: "white",
                padding: "1rem",
                backgroundColor: "orange",
                borderRadius:"20px"
              }}
            >
              <img className="git-logo" src="https://cdn-icons-png.flaticon.com/512/25/25231.png" width="20px"/> Github
            </button>
          </a>
        </div>
      </div>
    </Col>
  );
};
